import React from 'react'
import DateFnsUtils from '@date-io/date-fns'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { VoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomTextField'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import { ListItem, ListItemText, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { AccountFooter } from 'components/Footer/AccountFooter'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { useHistory, useLocation, useParams } from 'react-router-dom'

export const ProvisionImpairmentForm = (props: any) => {
  let history = useHistory()
  let location = useLocation()

  const editData: any = location?.state
  const { formMode } = props
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [openExitConf, setOpenExitConf] = useState(null)
  const [record, setRecord] = useState(false)
  const [, setIsFormDirty] = useState(true)

  let form, mode
  switch (formMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      break
    case 'edit':
      form = 'Draft'
      mode = 'edit'
      break
    case 'approve-reject':
      form = 'Approve'
      mode = 'approve-reject'
      break
    case 'resubmit':
      form = 'Resubmit'
      mode = 'edit'
      break
  }
  const { menu } = useMenuOption()

  /* -------------------------------------------- */
  /*                   USE FORM                   */
  /* -------------------------------------------- */
  const { register, setValue, control } = useForm<any>({
    defaultValues: {},
    mode: 'onSubmit',
  })

  /* -------------------------------------------- */
  /*                    QUERY                    */
  /* -------------------------------------------- */

  let dummyData = [
    {
      AssetName: 'Machinery',
      AssetNo: 'A-000013',
      StartDate: '2021-05-27T12:44:01.162Z',
      OriginalAmount: 1000,
      Desc: 'Change Description here',
      ModelNo: 'N/A',
      Quantity: 2,
      AccDeprecAmount: 0,
      AccImpairAmount: 0,
      AccImpairAmtReverse: 0,
      ResidualValue: 1.5,
      ResidualPercent: 0,
    },
  ]

  const draftFooterOption = {
    name: 'Save as Draft',
    onClick: () => {},
    color: 'primary',
    props: { type: 'submit' },
  }

  const rejectFooterOption = {
    name: 'Save',
    onClick: () => {},
    color: 'primary',
    props: { type: 'submit' },
  }

  const submitFooterOption = {
    name: 'Submit',
    onClick: e => {},
    color: 'primary',
    props: { type: 'submit' },
  }

  let footerOptions: any[]
  if (editData?.mode === 'resubmit') {
    footerOptions = [rejectFooterOption, submitFooterOption]
  } else {
    footerOptions = [draftFooterOption, submitFooterOption]
  }

  return (
    <>
      <MainHeader
        mainBtn="close"
        onClick={() => {
          history.push(
            `/fixed-assets/${CompanyID}/assets-change/provision-for-impairment`
          )
        }}
        smTitle={'Fixed Assets'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Provision Impairment', current: true },
        ]}
        rightRouteSegments={[
          {
            name:
              formMode === 'add'
                ? 'New'
                : formMode === 'approve-reject'
                ? 'Approve/Reject'
                : 'Edit',
            current: true,
          },
        ]}
      />

      <ContentWrapper float footer>
        <CardContents>
          <Controller
            render={({ value, onChange }) => {
              const defVal = dummyData?.filter(
                coa => coa?.AssetNo === editData?.AssetNo
              )[0]
              return (
                <Autocomplete
                  options={
                    dummyData?.sort((a, b) => {
                      return a?.AssetNo?.localeCompare(b?.AssetNo)
                    }) || []
                  }
                  getOptionLabel={option => `${option?.AssetNo}`}
                  fullWidth
                  onChange={(event, value: any) => {
                    if (value) {
                      setValue('AssetName', value?.AssetName)
                      setValue('StartDate', new Date(value?.StartDate))
                      setValue('OriginalAmount', value?.OriginalAmount)
                      setValue('Quantity', value?.Quantity)
                      setValue('ModelNo', value?.ModelNo)
                      setValue('AccDeprecAmount', value?.AccDeprecAmount)
                      setValue('AccImpairAmount', value?.AccImpairAmount)
                      setValue('ResidualValue', value?.ResidualValue)
                      setValue('ResidualPercent', value?.ResidualPercent)
                    }
                  }}
                  defaultValue={defVal}
                  disabled={mode === 'approve-reject'}
                  renderOption={(props, option) => {
                    return (
                      <div>
                        <div>
                          <span className="xsTitle">{props?.AssetNo}</span>
                        </div>
                      </div>
                    )
                  }}
                  renderInput={(params: any) => {
                    return (
                      <div>
                        <TextField
                          {...params}
                          label="Assets No."
                          style={{ width: '100%' }}
                          required
                          margin="normal"
                        />
                      </div>
                    )
                  }}
                />
              )
            }}
            label="Assets No."
            name="AssetNo"
            autoComplete="off"
            control={control}
            multiline={true}
            fullWidth
            margin="normal"
            ref={register}
            required
            defaultValue={editData?.AssetNo}
          />
          <Controller
            as={TextField}
            id="standard-basic"
            name="AssetName"
            label="Assets Name"
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            ref={register}
            defaultValue={menu?.obj?.AssetName ?? 'N/A'}
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              as={KeyboardDatePicker}
              name="StartDate"
              label="Start Date"
              control={control}
              format="dd/MM/yyyy"
              readOnly
              margin="dense"
              allowKeyboardControl
              ref={register}
              KeyboardButtonProps={{
                style: { display: 'none' },
              }}
              className="left"
              value={new Date()}
              defaultValue={menu?.obj?.StartDate ?? null}
              InputProps={{
                disableUnderline: true,
                readOnly: true,
              }}
            />
          </MuiPickersUtilsProvider>

          <Controller
            as={TextField}
            id="standard-basic"
            name="ModelNo"
            label="Model No"
            autoComplete="off"
            control={control}
            className="right"
            margin="dense"
            ref={register}
            defaultValue={menu?.obj?.ModelNo ?? 'N/A'}
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            name="OriginalAmount"
            label="Original Amount"
            autoComplete="off"
            control={control}
            className="left"
            margin="dense"
            ref={register}
            defaultValue={menu?.obj?.Quantity ?? 0}
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            ref={register}
            control={control}
            margin="dense"
            name="Quantity"
            label="Quantity"
            className="right"
            defaultValue={menu?.obj?.Quantity ?? 0}
            fixedDecimalScale
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            name="AccDeprecAmount"
            label="Acc. Depreciated Amount"
            ref={register}
            control={control}
            margin="dense"
            className="left"
            defaultValue={menu?.obj?.AccDeprecAmount ?? 0}
            decimalScale={2}
            fixedDecimalScale
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            name="AccImpairAmount"
            label="Accumulated Impairment"
            ref={register}
            control={control}
            margin="dense"
            className="right"
            defaultValue={menu?.obj?.AccDeprecAmount ?? 0}
            decimalScale={2}
            fixedDecimalScale
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            ref={register}
            control={control}
            margin="dense"
            name="AccImpairAmtReverse"
            label="Accumulated Impairment Reversal"
            className="left"
            defaultValue={menu?.obj?.AccImpairAmtReverse ?? 0}
            decimalScale={2}
            fixedDecimalScale
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            ref={register}
            control={control}
            margin="dense"
            name="ResidualValue"
            label="Residual Value"
            className="right"
            defaultValue={menu?.obj?.ResidualValue ?? 0}
            decimalScale={2}
            fixedDecimalScale
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            ref={register}
            control={control}
            margin="dense"
            name="ResidualPercent"
            label="Residual (%)"
            className="left"
            defaultValue={menu?.obj?.ResidualPercent ?? 0}
            decimalScale={4}
            fixedDecimalScale
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />
        </CardContents>

        <CardContents
          section={{
            header: {
              title: 'Provision for Impairment',
            },
          }}
        >
          <>
            <Controller
              as={KeyboardDatePicker}
              name="ChangeDate"
              label="Change Date"
              control={control}
              format="dd/MM/yyyy"
              margin="dense"
              allowKeyboardControl
              ref={register}
              KeyboardButtonProps={{
                'aria-label': 'change date',
                style: { display: 'none' },
              }}
              className="left"
              value={new Date()}
              defaultValue={editData ? editData?.ChangeDate : new Date()}
              required
            />

            <Controller
              as={<NumberFormat allowNegative={false} />}
              thousandSeparator
              customInput={TextField}
              ref={register}
              control={control}
              margin="dense"
              name="ChangedProvisionAmount"
              label="Provision Amount"
              className="right"
              defaultValue={menu?.obj?.ChangedProvisionAmount ?? 0}
              decimalScale={2}
              fixedDecimalScale
              required
            />

            <VoiceTextField
              mounted={true}
              label="Description"
              name="Desc"
              setValue={setValue}
              record={record}
              setRecord={setRecord}
              setIsFormDirty={setIsFormDirty}
              control={control}
              controllerProps={{
                ref: register,
                autoComplete: 'off',
              }}
              required
            />

            <VoiceTextField
              mounted={true}
              label="Reason"
              name="Reason"
              setValue={setValue}
              record={record}
              setRecord={setRecord}
              setIsFormDirty={setIsFormDirty}
              control={control}
              controllerProps={{
                ref: register,
                autoComplete: 'off',
              }}
              required
            />
          </>
        </CardContents>
      </ContentWrapper>

      {footerOptions?.length > 0 && (
        <AccountFooter options={[...footerOptions]} />
      )}

      <CommonDialog
        fullWidth={true}
        open={errorDia}
        onClose={() => setErrorDia(false)}
        sections={{
          header: {
            children: (
              <ListItem className="remove-padding">
                <ListItemText
                  primary={
                    <>
                      <span
                        className="smTitle flex-space"
                        style={{ color: 'red' }}
                      >
                        {'Document Numbering is empty'}
                      </span>
                    </>
                  }
                />
              </ListItem>
            ),
          },
          body: () => (
            <div>
              <span>{'Please setup Document Numbering to Submit'}</span>
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => setErrorDia(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/fixed-assets/${CompanyID}/provision-for-impairment`)
        }}
      />
    </>
  )
}
